import React from 'react';

import { Flex } from '@chakra-ui/react';

const Assets = () => <Flex>Assets</Flex>;

export default Assets;
